import { StackNavigationProp, createStackNavigator } from "@react-navigation/stack";
import React from "react";

import AddressList from "@/screens/Address/AddressList";
import NewAddress from "@/screens/Address/NewAddress";

export type AddressStackParamList = {
  addressList: undefined;
  newAddress: undefined;
};

export const AddressRoutePaths = {
  addressList: "meus-enderecos",
  newAddress: "novo-endereco",
};

export type AddressNavigation = StackNavigationProp<AddressStackParamList>;

const AddressStackNav = createStackNavigator<AddressStackParamList>();

export const AddressStack = () => {
  return (
    <AddressStackNav.Navigator
      initialRouteName="addressList"
      screenOptions={{ headerShown: false, headerMode: "screen" }}>
      <AddressStackNav.Screen
        name="addressList"
        component={AddressList}
        options={{ title: "Endereços" }}
      />
      <AddressStackNav.Screen
        name="newAddress"
        component={NewAddress}
        options={{ title: "Novo Endereço" }}
      />
    </AddressStackNav.Navigator>
  );
};
